import { isSessionExpired, SESSION_EXPIRED_MESSAGE } from "./sessionErrors";

/* What failed, in plain words — never a bare "couldn't update". The server's
   own detail wins (409 "already approved", 404 "no longer exists", 403 "only
   an owner, admin or manager"); a 5xx says the server broke and nothing saved. */
export const timeOffErrorMessage = (err, verb = "update") => {
  const status = Number(err?.status || err?.response?.status || 0);
  const detail = err?.payload?.detail || err?.response?.data?.detail;
  if (isSessionExpired(err)) return SESSION_EXPIRED_MESSAGE;
  if (detail && status < 500) return detail;
  if (status >= 500) return `The server hit an error and didn’t ${verb} the request — nothing was saved. Try again; if it repeats, tell Abon support (HTTP ${status}).`;
  if (!status) return `Couldn’t reach the server to ${verb} the request — check your connection and try again.`;
  return `The server refused to ${verb} the request (HTTP ${status}).`;
};
